<template>
  <div class='body-box marginBox2'>
    <el-row class='plan'></el-row>

    <el-form
      ref='editFormRef'
      :model='editForm'
      label-width='140px'
      style='padding: 20px;background-color: #fff;margin-top: 10px;'
    >
      <el-row>
        <!--球场名称-->
        <el-col :span='8'>
          <el-form-item label='比赛名称'>
            <el-input v-model='editForm.name' />
          </el-form-item>
        </el-col>

        <!--希望球场-->
        <el-col :span='8'>
          <el-form-item label='希望球场'>
            <el-input v-model='editForm.courtName' />
          </el-form-item>
        </el-col>

        <!--开始日-->
        <el-col :span='8'>
          <el-form-item label='开始日'>
            <el-date-picker style='width: 100%;' v-model='editForm.raceDate' type='date'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span='8'>
          <el-form-item label='打球时间起'>
            <el-time-picker value-format='HH:mm' v-model='editForm.raceTime' style='width: 100%;'></el-time-picker>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span='8'>
          <el-form-item label='打球时间至'>
            <el-time-picker value-format='HH:mm' v-model='editForm.raceEndTime'
                            style='width: 100%;'></el-time-picker>
          </el-form-item>
        </el-col>

        <!--预约人-->
        <el-col :span='8'>

          <el-form-item label='预约人'>
            <el-input v-model='editForm.userName' />
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span='8'>
          <el-form-item label='预约人电话'>
            <el-input v-model='editForm.tel' />
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span='8'>
          <el-form-item label='预约人邮箱'>
            <el-input v-model='editForm.email' />
          </el-form-item>
        </el-col>

        <!--组数-->
        <el-col :span='8'>
          <el-form-item label='组数'>
            <el-input v-model='editForm.num' />
          </el-form-item>
        </el-col>

        <!--方式-->
        <el-col :span='8'>
          <el-form-item label='方式'>
            <el-select v-model='editForm.kickOffMode' clearable placeholder='请选择方式' style='width: 100%'>
              <el-option v-for='item in raceWay' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--计算方式-->
        <el-col :span='8'>
          <el-form-item label='计算方式'>
            <el-select v-model='editForm.record' clearable placeholder='请选择方式' style='width: 100%'>
              <el-option v-for='item in calculation' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--成绩表-->
        <el-col :span='8'>
          <el-form-item label='成绩表'>
            <el-select v-model='editForm.gradeTable' clearable placeholder='请选择成绩表' style='width: 100%'>
              <el-option v-for='item in gradeTable' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--食物-->
        <el-col :span='8'>
          <el-form-item label='食物'>
            <el-select v-model='editForm.food' clearable placeholder='请选择食物' style='width: 100%'>
              <el-option v-for='item in raceFood' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--班车-->
        <el-col :span='8'>
          <el-form-item label='班车'>
            <el-select v-model='editForm.bus' clearable placeholder='请选择食物' style='width: 100%'>
              <el-option v-for='item in shuttleBus' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--其他-->
        <el-col :span='8'>
          <el-form-item label='其他'>
            <el-input v-model='editForm.other' />
          </el-form-item>
        </el-col>

        <!--旗-->
        <el-col :span='8'>
          <el-form-item label='远近洞'>
            <el-select v-model='editForm.prize' clearable placeholder='请选择远近洞' style='width: 100%' @change='distance'>
              <el-option key='YES' label='要' value='YES'></el-option>
              <el-option key='NO' label='不要' value='NO'></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <!--近洞奖-->
        <el-col :span='8'>
          <el-form-item label='近洞奖'>
            <el-input :disabled="editForm.prize === 'YES'" v-model='editForm.nearHoleAward' />
          </el-form-item>
        </el-col>

        <!--远距奖-->
        <el-col :span='8'>
          <el-form-item label='近洞奖'>
            <el-input :disabled="editForm.prize === 'YES'" v-model='editForm.distanceAward' />
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span='24'>
          <el-form-item label='备注'>
            <el-input type='textarea' v-model='editForm.brief' />
          </el-form-item>
        </el-col>

        <!--修改打球人-->
        <el-col :span='24' style='padding: 20px 58px;font-size: 16px'>
          <span>打球列表:</span>
          <el-button style='margin-left: 10px' size='small' round @click='dialogVisible=true'>添加打球人</el-button>
        </el-col>
        <el-col :span='24' v-for='(item,index) in editForm.groupPerson' :key='item.type'>
          <el-row>
            <el-col style='margin-left: 136px;'>
              <el-select v-for='u in item.data' :key='u.id' v-model='u.name' placeholder='请选择打球人'
                         style='margin-right: 50px;margin-top: 15px'>
                <el-option
                  v-for='item in contactPersons'
                  :key='item.id'
                  :label='item.name'
                  :value='item.id'>
                </el-option>
              </el-select>
              <span class='el-icon-remove-outline'
                    style='font-size: 20px;cursor: pointer;margin-left: 5px'
                    @click='deleteContactPersons(index)'></span>
              <span class='el-icon-circle-plus-outline'
                    style='margin-left: 10px;font-size: 20px;cursor: pointer;'
                    @click='addContactPersons(index,item.type)' v-if='(editForm.groupPerson.length-1)===index'></span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <!--添加打球人-->
    <el-dialog
      title='添加打球人'
      :visible.sync='dialogVisible'
      width='30%'>
      <el-input v-model='name' placeholder='请输入打球人姓名' style='width: 30%'></el-input>
      <span slot='footer' class='dialog-footer'>
            <el-button @click='dialogVisible = false' size='small' round>取 消</el-button>
            <el-button type='primary' @click='addGroupPerson' size='small' round>确 定</el-button>
          </span>
    </el-dialog>

    <div class="goBackBox">
      <el-button @click='goBack'>返回</el-button>
      <el-button @click='submitModifyOrder'>修改订单</el-button>
    </div>
  </div>
</template>

<script>
import { modifyOrderRacesById } from '@/api/order/order'
import { raceWay, calculation, gradeTable, raceFood, shuttleBus } from '@/js/enum'
import { addContactPersons, getContactPersonsByUserId } from '@/api/contactPersons/contactPersons'
import { getData } from '@/utils/code'
import { checkArrayRepeat, getId } from '@/utils/utils'

export default {
  name: 'updateGameOrder',
  data() {
    return {
      dialogVisible: false,
      name: '',
      editForm: {},
      groupPerson: [],
      orderId: '',
      newContent: {},
      newGroupPerson: [],
      raceWay: raceWay,
      calculation: calculation,
      gradeTable: gradeTable,
      raceFood: raceFood,
      shuttleBus: shuttleBus,
      contactPersons: []
    }
  },

  mounted() {
    this.orderId = this.$route.query.id
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      let data = localStorage.getItem(this.orderId)
      if (data) {
        this.editForm = JSON.parse(data)
        this.getContactPersons(this.editForm.userId)
      } else {
        this.$message.info('获取比赛数据失败!')
      }
    },
    //获取打球人
    getContactPersons(userId) {
      getContactPersonsByUserId(userId).then((res) => {
        this.contactPersons = getData(res) ? getData(res) : []
      })
    },
    //返回
    goBack() {
      this.$router.go(-1)
    },

    distance() {
      if (this.editForm.prize === 'YES') {
        this.editForm.distanceAward = 0
        this.editForm.nearHoleAward = 0
      }
    },

    //替换打球人
    replace() {
      this.groupPerson = this.newGroupPerson
    },

    submitModifyOrder() {
      let personNum = 0
      let gp = []
      if (this.editForm.groupPerson.length > 0) {
        gp = JSON.parse(JSON.stringify(this.editForm.groupPerson))
        gp.forEach((item, i) => {
          item.data.forEach((data, index) => {
            if (data.name) {
              personNum += 1
            } else {
              gp[i].data.splice(index, 4)
            }
          })
          if (item.data.length === 0) {
            gp.splice(i, 1)
          }
        })
      }
      // 验证名字是否有重复
      let check = checkArrayRepeat(this.editForm.groupPerson, personNum)
      if (!check) {
        this.$message.info('不能有相同的打球人!')
        return
      }
      const data = {
        brief: this.editForm.brief,
        bus: this.editForm.bus,
        courtName: this.editForm.courtName,
        distanceAward: this.editForm.distanceAward,
        email: this.editForm.email,
        enumStatus: this.editForm.enumStatus,
        food: this.editForm.food,
        gradeTable: this.editForm.gradeTable,
        groupPerson: JSON.stringify(gp),
        kickOffMode: this.editForm.kickOffMode,
        name: this.editForm.name,
        nearHoleAward: this.editForm.nearHoleAward,
        num: this.editForm.num,
        other: this.editForm.other,
        personNum: personNum,
        prize: this.editForm.prize,
        raceDate: this.editForm.raceDate,
        raceEndTime: this.editForm.raceEndTime,
        raceTime: this.editForm.raceTime,
        record: this.editForm.record,
        tel: this.editForm.tel,
        userName: this.editForm.userName
      }

      modifyOrderRacesById(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功!')
          localStorage.removeItem(this.orderId)
          this.goBack()
        }
      })
    },
    //增加一组
    addContactPersons(index, type) {
      let d = {
        type: parseInt(type) + 1,
        data: [
          {
            id: getId(10)
          },
          {
            id: getId(10)
          },
          {
            id: getId(10)
          },
          {
            id: getId(10)
          }
        ]
      }
      this.editForm.groupPerson.push(d)
    },
    //删除一组
    deleteContactPersons(index) {
      if ((this.editForm.groupPerson.length - 1)===0) {
        this.$message.info('至少留一组!')
        return
      }
      this.editForm.groupPerson.splice(index, 1)
    },
    //添加打球人
    addGroupPerson() {
      if (this.name === '') {
        this.$message.info('请输入打球人姓名!')
        return
      }
      let data = {
        name: this.name,
        userId: this.editForm.userId
      }
      addContactPersons(data).then((res) => {
        let data = getData(res)
        if (data !== null) {
          this.$message.success('添加成功')
          this.name = ''
          this.getContactPersons(this.editForm.userId)
          this.dialogVisible = false
        }
      })
    }

  }
}
</script>

<style lang='less' scoped>
.colorStatus {
  color: red;
}
</style>
